@if(dataVisible$ | async) {
  <form [formGroup]="formGroup">
    @if((this.formGroup.get('winstUitOnderneming')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Winst uit onderneming</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="winstUitOnderneming"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

      @if((this.formGroup.get('loonAlsOnderdeelVanWinst')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col col-1">
            <p>Af: loon begrepoen in winst uit onderneming</p>
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="loonAlsOnderdeelVanWinst"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
        </div>
      }
    }

    @if((this.formGroup.get('inLijfrenteOmgezetteForBijStaking')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Af: premie lijfrente in verband met afname fiscale oudedagsreserve bij
            staking</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inLijfrenteOmgezetteForBijStaking"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('inLijfrenteOmgezetteForNietBijStaking')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Af: premie lijfrente in verband met afname fiscale oudedagsreserve</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inLijfrenteOmgezetteForNietBijStaking"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('loonBuitenlandVoorZvw')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Buitenlands loon</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="loonBuitenlandVoorZvw"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('vrijgesteldLoonVoorZvw')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Vrijgestelde loon</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="vrijgesteldLoonVoorZvw"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('resultaatUitOverigeWerkzaamheden')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Resultaat overige werkzaamheden (excl. TBS)</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="resultaatUitOverigeWerkzaamheden"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('periodiekeUitkeringen')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Periodieke uitkeringen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="periodiekeUitkeringen"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((this.formGroup.get('loonWaaroverIsGeheven')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1">
          <p>Overig inkomen waarover al is geheven</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="loonWaaroverIsGeheven"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    <div class="row">
      <div class="col col-1">
        <p>Totaal bijdrage-inkomen (maximaal € {{ (formGroup.controls.maxPremieLoon.value ?? 0) | number: '1.0-0' }})</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="bijdrageInkomen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>

    <div class="row">
      <div class="col col-1">
        <p>Inkomen waarover nog premie verschuldigd is</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [decimals]="0"
                                          [calculate]="grondslagZvwPremie"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="totaalBijdrageInkomenNaMaxEnLoon"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>

    <div class="row">
      <div class="col col-1">
        <p><b>Verschuldigde premie
            zorgverzekeringswet {{ isPartner ? 'partner' : 'aangever'}}</b>: {{ this.formGroup.get('percentageZvw')?.value | number: '1.0-2' }}
          % van
          € {{ this.formGroup.get('totaalBijdrageInkomenNaMaxEnLoon')?.value | number: '1.0-0' }}</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="verschuldigdeZvw"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>

    @if((this.formGroup.get('voorlopigeAanslagZvw')?.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: betaald via voorlopige aanslag(en)</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="voorlopigeAanslagZvw"
                                            id="voorlopigeAanslagZvw"
                                            placeholder="-"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>

    <div class="row">
      <div class="col col-1">
        <p><b>Te betalen</b></p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="verschuldigdePremie"
                                          id="verschuldigdePremie"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    }
  </form>
}
